import { useState } from 'react'
import { Info } from 'lucide-react'
import clsx from 'clsx'

interface ConfidenceBadgeProps {
  level: 'high' | 'medium' | 'low'
  rationale?: string
}

export default function ConfidenceBadge({ level, rationale }: ConfidenceBadgeProps) {
  const [showRationale, setShowRationale] = useState(false)

  const labels = {
    high: 'High Confidence',
    medium: 'Medium Confidence',
    low: 'Low Confidence',
  }

  return (
    <div className="relative">
      <button
        onClick={() => rationale && setShowRationale(!showRationale)}
        className={clsx(
          'badge flex items-center gap-2 transition-all duration-200',
          level === 'high' && 'confidence-glass-high',
          level === 'medium' && 'confidence-glass-medium',
          level === 'low' && 'confidence-glass-low',
          rationale && 'cursor-pointer hover:scale-105'
        )}
        aria-expanded={showRationale}
        aria-describedby={showRationale ? 'confidence-rationale' : undefined}
      >
        <span
          className={clsx(
            'w-2 h-2 rounded-full',
            level === 'high' && 'bg-white/80',
            level === 'medium' && 'bg-white/80',
            level === 'low' && 'bg-white/80'
          )}
        />
        {labels[level]}
        {rationale && (
          <Info className="w-3.5 h-3.5 opacity-80" />
        )}
      </button>

      {/* Rationale tooltip */}
      {showRationale && rationale && (
        <div
          id="confidence-rationale"
          className={clsx(
            'absolute top-full left-0 z-10',
            'w-64 bg-[var(--surface)] shadow-lg border border-[var(--bbs-color-border)]',
            'text-sm text-[var(--bbs-text-secondary)]'
          )}
          style={{
            marginTop: 'var(--bbs-spacing-sm)',
            padding: 'var(--bbs-spacing-md)',
            borderRadius: 'var(--bbs-radius-sm)'
          }}
        >
          <p className="font-medium text-[var(--bbs-text-primary)] mb-2">
            Why this confidence level?
          </p>
          <p>{rationale}</p>
        </div>
      )}
    </div>
  )
}
